module.exports = __webpack_public_path__ + "static/2-d0c87ec8be8611f09f6482364bc00609.jpg";